import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f927de4e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=f927de4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f927de4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f927de4e')) {
      api.createRecord('f927de4e', component.options)
    } else {
      api.reload('f927de4e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f927de4e&scoped=true&", function () {
      api.rerender('f927de4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t3OSiYSlJQ7X/JS/comp/SearchFilterTokens.vue"
export default component.exports